import { Component, OnInit, Input, ElementRef, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ModalService } from '@frontend/unhideschool/shared/components/modal/modal.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'unh-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('openClose', [
      state('open', style({
        display: 'block'
      })),
      state('closed', style({
        display: 'none'
      })),
      transition('open => closed', [
        animate('0.1s ease-in-out')
      ]),
      transition('closed => open', [
        animate('0.1s ease-in-out')
      ]),
    ]),
  ],
})
export class ModalComponent implements OnInit {
  @Input() id: string;
  private element: any;
  isOpen = false;

  constructor(private modalService: ModalService, private el: ElementRef) {
    this.element = el.nativeElement;
  }

  ngOnInit(): void {
    // ensure id attribute exists
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    // move element to bottom of page (just before </body>) so it can be displayed above everything else
    document.body.appendChild(this.element);

    // close modal on background click
    this.element.addEventListener('click', el => {
      if (el.target.className === 'unh-modal') {
        this.close();
      }
    });

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);
  }

  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  // open modal
  open(): void {
    //this.element.querySelector('.modal-container').style.display = 'block';
    this.isOpen = true;
    document.body.classList.add('unh-modal-open');
  }

  // close modal
  close(): void {
    //this.element.querySelector('.modal-container').style.display = 'none';
    this.isOpen = false;
    document.body.classList.remove('unh-modal-open');
  }
}
